import React, { useEffect } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import AddSubCategoryForm from '../../../component/subcategoryComps/addSubCategoryForm';

const AddSubCategory = () => {

  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getCategoryHeirarchy());
  }, []);

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Subcategory"  pagename="Add Subcategory" buttonText="Save"/>
      <AddSubCategoryForm />
    </div>
  );
};

export default AddSubCategory;
